<template>
    <div class="m-calendar">
        <div class="m-calendar__header">
            <span
                class="material-icons m-calendar__button"
                @click="subtractMonth"
                >keyboard_arrow_left</span
            >
            <p class="m-calendar__title o-dashboardDelivery__title">
                {{ month + ' - ' + year }}
            </p>
            <span class="material-icons m-calendar__button" @click="addMonth"
                >keyboard_arrow_right</span
            >
        </div>
        <div class="m-calendar__weekdays">
            <div
                v-for="(weekDay, weekDayIdx) in days"
                v-bind:key="weekDayIdx"
                class="m-calendar__weekdaysDay"
            >
                {{ weekDay }}
            </div>
        </div>
        <div v-if="calendarStatus !== 'pending'" class="m-calendar__dates">
            <div
                v-for="blank in firstDayOfMonth"
                v-bind:key="`blank${blank}`"
                class="m-calendar__day m-calendar__day--blank"
            ></div>
            <div
                v-for="(day, dayIdx) in daysInMonth"
                v-bind:key="dayIdx"
                class="m-calendar__day"
                @click="
                    day.deliveries[0] && day.deliveries[0].id
                        ? openModal(day.deliveries)
                        : false
                "
                :class="{
                    'm-calendar__day--current': day.today,
                    'm-calendar__day--planned':
                        day.deliveries &&
                        day.deliveries[0].status === 'Planowana dostawa',
                    'm-calendar__day--delivered': day.status === 'Dostarczono'
                }"
            >
                <div class="m-calendar__dayContent">
                    <span class="m-calendar__dayContentDay">{{
                        dayIdx + 1
                    }}</span>
                    <span
                        v-if="day.has_complaint"
                        class="m-calendar__dayContentIcon"
                    >
                        <a-icon icon="ExclamationRed" />
                    </span>
                    <span
                        v-else-if="day.supplied"
                        class="m-calendar__dayContentIcon"
                    >
                        <a-icon icon="CheckmarkGreen" />
                    </span>
                    <div
                        @click="addOrder(dayIdx)"
                        v-if="isDaySupported(dayIdx) && !day.deliveries"
                        class="m-calendar__addOrder"
                    >
                        <svg
                            width="24"
                            height="24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="12" cy="12" r="12" fill="#5DA538" />
                            <path
                                d="M12.2 8.4V16m-3.8-3.8H16"
                                stroke="#fff"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>
                    <p
                        v-if="day.deliveries && day.deliveries[0].status"
                        class="a-text m-calendar__dayContentStatus"
                    >
                        <span
                            v-if="day.today"
                            class="m-calendar__dayContentStatusToday"
                            >Dzisiaj</span
                        >
                        {{
                            day.deliveries && day.deliveries[0].status
                                ? day.deliveries[0].status
                                : ''
                        }}
                    </p>
                </div>
            </div>
        </div>
        <div v-else class="m-calendar__loader">
            <a-icon icon="Spinner" />
        </div>
        <dashboard-calendar-modal
            v-if="addressId !== null"
            @delivery-cancel="$emit('delivery-cancel')"
            :address-id="addressId"
        />
    </div>
</template>

<script>
import moment from 'moment'
import DashboardCalendarModal from '@/components/dashboard/DashboardCalendarModal'
export default {
    components: {
        DashboardCalendarModal
    },
    props: {
        monthDeliveries: {
            type: Array,
            required: false
        },
        calendarStatus: {
            type: String,
            default: 'idle'
        },
        supportedDays: {
            type: Array,
            required: false
        },
        addressId: {
            type: Number,
            required: false
        }
    },
    data() {
        return {
            today: moment().locale('pl'),
            dateContext: moment().locale('pl'),
            days: [
                'Poniedziałek',
                'Wtorek',
                'Środa',
                'Czwartek',
                'Piątek',
                'Sobota',
                'Niedziela'
            ],
            months: this.updatePlMonths()._nominative,
            selectedMonth: `${this.month} ${this.year}`
        }
    },
    watch: {
        // totalAmountValue() {
        //     this.checkAmount()
        // }
    },
    computed: {
        weekOrders() {
            return this.$store.getters.weekOrders
        },
        year() {
            return this.dateContext.format('Y')
        },
        month() {
            return this.dateContext.format('MMMM')
        },
        daysInMonth() {
            const days = Array(this.dateContext.daysInMonth()).fill({})
            days.forEach((day, dayIdx) => {
                const formatedDay = `${this.dateContext.format('YYYY-MM')}-${(
                    dayIdx + 1
                )
                    .toString()
                    .padStart(2, '0')}`
                // merge delivered
                this.monthDeliveries.forEach(item => {
                    if (moment(item.execution_date).isSame(formatedDay)) {
                        this.$set(days, dayIdx, {
                            ...days[dayIdx],
                            deliveries: [
                                ...(days[dayIdx].deliveries || []),
                                item
                            ]
                        })
                    }
                })
                // mark today
                if (formatedDay === this.today.format('YYYY-MM-DD')) {
                    this.$set(days, dayIdx, { ...days[dayIdx], today: true })
                }
            })
            return days
        },
        currentDate() {
            return this.dateContext.get('date')
        },
        firstDayOfMonth() {
            const firstDay = moment(this.dateContext).subtract(
                this.currentDate - 1,
                'days'
            )
            return firstDay.weekday()
        },
        initialDate() {
            return this.today.get('date')
        },
        initialMonth() {
            return this.today.format('MMMM')
        },
        initialYear() {
            return this.today.format('Y')
        },
        minimumDate() {
            return this.$store.getters.minimumDate
        },
        addresses() {
            return this.$store.getters['companies/addresses']
        },
        address() {
            return this.$store.getters['companies/addresses'].find(
                address => address.id === this.addressId
            )
        },
        warehouseId() {
            return this.address ? this.address.warehouse_id : null
        },
        externalSupplier() {
            return this.address
                ? this.address.external_supplier
                    ? 1 : 0
                : null
        },
        thresholdAmount() {
            return this.$store.getters.thresholdAmount
        },
        totalAmountValue() {
            return this.$store.getters.totalAmount
        },
        thresholdAmountMessage() {
            return this.$store.getters.thresholdAmountMessage
        }
    },
    methods: {
        addMonth() {
            this.dateContext = moment(this.dateContext).add(1, 'month')
            this.emitMonthChange()
        },
        subtractMonth() {
            this.dateContext = moment(this.dateContext).subtract(1, 'month')
            this.emitMonthChange()
        },
        selectMonth() {
            this.dateContext = moment(this.dateContext).month(
                this.selectedMonth
            )
        },
        openModal(id) {
            this.$store.dispatch('modalShow', {
                name: 'dashboardCalendarModal',
                payload: {
                    id
                }
            })
        },
        updatePlMonths() {
            const localeData = moment.updateLocale('pl', {
                nominative: 'Styczeń_Luty_Marzec_Kwiecień_Maj_Czerwiec_Lipiec_Sierpień_Wrzesień_Październik_Listopad_Grudzień'.split(
                    '_'
                )
            })
            return localeData
        },
        dayCurrent(day) {
            return (
                day === this.initialDate &&
                this.month === this.initialMonth &&
                this.year === this.initialYear
            )
        },
        dayDelivered(day) {
            return this.monthDeliveries.find(item =>
                moment(item.execution_date).isSame(
                    `${this.dateContext.format(
                        'YYYY-MM'
                    )}-${day.toString().padStart(2, '0')}`
                )
            )
        },
        emitMonthChange() {
            this.$emit('month-change', this.dateContext.format('YYYY-MM'))
        },
        isDaySupported(dayIdx) {
            if (this.minimumDate) {
                const dayInWeek = ((this.firstDayOfMonth + dayIdx) % 7) + 1
                if (
                    dayInWeek > 5 ||
                    moment(this.minimumDate).isAfter(
                        `${this.dateContext.format('YYYY-MM')}-${dayIdx + 1}`
                    )
                ) {
                    return false
                }
                const day = this.supportedDays.find(
                    day => day.day === dayInWeek
                )
                return day ? day.is_active : false
            }
        },
        addOrder(dayIdx) {
            this.$store
                .dispatch(
                    'resetFromInitialState',
                    { module: 'deliveries' },
                    { root: true }
                )
                .then(() => {
                    this.$store
                        .dispatch('addAddressWithId', {
                            addressId: this.addressId,
                            newAddress: false
                        })
                        .then(() => {
                            // check for supported days
                            const selectedAddress = this.addresses.find(
                                address => address.id === this.addressId
                            )
                            if (!selectedAddress) {
                                throw Error('No details in selected address')
                            }
                            this.$store
                                .dispatch('checkSupportedDaysAndSave', {
                                    geometry: {
                                        lat: selectedAddress.latitude,
                                        lng: selectedAddress.longitude
                                    },
                                    warehouse: {
                                        id: selectedAddress.warehouse_id
                                    },
                                    companySize: this.companySize,
                                    // check all days
                                    days: 0,
                                    // check if new address
                                    newAddress: !this.isSecondStep
                                })
                                .then(() => {
                                    const dayInWeek =
                                        (this.firstDayOfMonth + dayIdx) % 7
                                    this.$router.push({
                                        name: 'cart',
                                        params: { day: dayInWeek }
                                    })
                                })
                        })
                })
        },
        fetchPackages() {
            this.$store.dispatch('fetchPackages', {
                warehouseId: this.warehouseId,
                externalSupplier: this.externalSupplier
            })
        },
        fetchPackageCategories() {
            this.$store.dispatch('fetchPackageCategories', {
                warehouseId: this.warehouseId,
                externalSupplier: this.externalSupplier
            })
        },
        fetchFeaturedPackages() {
            this.$store.dispatch('fetchFeaturedPackages', {
                warehouseId: this.warehouseId,
                companySize: 1,
                externalSupplier: this.externalSupplier
            })
        },
        fetchSettings() {
            this.$store.dispatch('fetchSettings').then(() => {
                this.$store.dispatch('checkMinimumCartDate')
            })
        },
        fetchAddressAttrs() {
            this.$store.dispatch('fetchPricelists').then(() => {
                this.$store.dispatch('fetchMutablePricelists').then(() => {
                    if (typeof this.warehouseId === 'number') {
                        this.$store
                            .dispatch('addAddressWithId', {
                                addressId: this.addressId,
                                newAddress: false
                            })
                        this.fetchPackageCategories()
                        this.fetchPackages()
                        this.fetchFeaturedPackages()
                    }
                })
            })
            this.$store.dispatch('fetchDiscountCategories')
            this.$store.dispatch('fetchDiscounts')
            this.fetchSettings()
        },
        checkAmount() {
            if(this.thresholdAmount !== null && this.totalAmountValue > this.thresholdAmount) {
                this.$store.dispatch('modalHide')
                this.$store.dispatch('modalShow', {
                    name: 'thresholdAmount',
                    payload: {
                        message: this.thresholdAmountMessage
                    }
                })
            }
        }
    },
    mounted() {
        // Add polish month names to moment
        this.updatePlMonths()
        this.selectedMonth = `${this.month} ${this.year}`
        this.emitMonthChange()
        this.$store.dispatch('fetchSettings')
        this.fetchAddressAttrs()
    }
}
</script>
